// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aF9m","icon":"styles_icon__n30w3"};